import { useLocale } from "next-intl";

const useIsRightToLeft = () => {
  const locale = useLocale();
  return locale === "ar";
};

export default useIsRightToLeft;
